import { useTranslation } from "react-i18next";
import type { SourcingEventDto } from "../../../autogen/bff-api";
import { useDisplayDateWithTime } from "../../../common/formatting/useDisplayDateWithTime";
import { isBidDeadlineStillOpen } from "../award/canSelectWinner";
import { effectiveBidDeadline } from "../qualification/stage";
import { eventIsDesignContest } from "../../sourcing-events/buyer/wizard/utils/designContest";

export const useCompleteEvaluationDescription = (event: SourcingEventDto): (() => string) => {
  const { t } = useTranslation();
  const displayDateWithTime = useDisplayDateWithTime();

  return () => {
    if (event.entriesAnonymous) {
      return t(
        "The jury's ranking is final and everyone working on the procurement sees who is behind each entry. The entries cannot be made anonymous again.",
      );
    }
    if (eventIsDesignContest(event)) {
      return t("The jury's ranking is final again. You can reopen it later.");
    }
    const frozen = t("The scores and the price selection are frozen. You can reopen it later.");
    const deadline = effectiveBidDeadline(event);
    if (deadline == null || !isBidDeadlineStillOpen(event, Date.now())) return frozen;
    const stillOpen = t(
      "The bid deadline {{date}} has not passed yet. Suppliers can still deliver or change their bids, and you can award only after the deadline.",
      { date: displayDateWithTime(deadline) },
    );
    return `${frozen} ${stillOpen}`;
  };
};
